(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 92119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27812);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36697);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var app_components_stations_list_stations_list_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79666);
/* harmony import */ var services_hooks_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var app_components_podcats_list_podcast_list_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60151);
/* harmony import */ var app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71014);
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91289);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);














var Home = function Home() {
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_9__/* .useTranslate */ .q)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();

  var _useGetPillowCategori = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useGetPillowCategoriesPath */ .Bs)("radioline_selection", {
    pageSize: 10
  }),
      data = _useGetPillowCategori.data,
      error = _useGetPillowCategori.error,
      stationsLoading = _useGetPillowCategori.isLoading,
      fetchNextPageStations = _useGetPillowCategori.fetchNextPage;

  var _useGetPillowCategori2 = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useGetPillowCategoriesPath */ .Bs)("podcasts_selection", {
    pageSize: 10
  }),
      podcastData = _useGetPillowCategori2.data,
      podcastError = _useGetPillowCategori2.error,
      podcastsLoading = _useGetPillowCategori2.isLoading,
      fetchNextPagePodcasts = _useGetPillowCategori2.fetchNextPage;

  var radioSelectionList = (data === null || data === void 0 ? void 0 : data.pages.reduce(function (acc, current) {
    var _current$data$body;

    if ((_current$data$body = current.data.body) !== null && _current$data$body !== void 0 && _current$data$body.content) {
      acc = [].concat((0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(acc), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(current.data.body.content));
    }

    return acc;
  }, [])) || [];
  var podcastSelectionList = (podcastData === null || podcastData === void 0 ? void 0 : podcastData.pages.reduce(function (acc, current) {
    var _current$data$body2;

    if ((_current$data$body2 = current.data.body) !== null && _current$data$body2 !== void 0 && _current$data$body2.content) {
      acc = [].concat((0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(acc), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(current.data.body.content));
    }

    return acc;
  }, [])) || [];
  (0,app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_5__/* .useGoBackHistory */ .J)("INDEX");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("title", {
        children: "Radioline"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_6__/* .NextSeo */ .PB, {
      title: t("seo_title_home"),
      titleTemplate: "%s",
      description: t("seo_description_home"),
      languageAlternates: [].concat((0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((router.locales || []).filter(function (locale) {
        return locale !== "defaultLang";
      }).map(function (locale) {
        return {
          hrefLang: locale,
          href: "https://www.radioline.co/".concat(locale)
        };
      })), [{
        href: "https://www.radioline.co/en",
        hrefLang: "x-default"
      }]),
      canonical: router.locale !== "defaultLang" ? "https://www.radioline.co/".concat(router.locale) : "https://www.radioline.co/en",
      openGraph: {
        images: [{
          url: "https://www.radioline.co/open-graph.png",
          alt: "Radioline"
        }]
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(app_components_stations_list_stations_list_component__WEBPACK_IMPORTED_MODULE_1__/* .StationsList */ .e, {
      label: t("tabs.stations"),
      items: radioSelectionList,
      loading: stationsLoading,
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().home_stations_wrapper),
      fetchNextPage: fetchNextPageStations
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(app_components_podcats_list_podcast_list_component__WEBPACK_IMPORTED_MODULE_4__/* .PodcastList */ .k, {
      label: t("tabs.podcasts"),
      items: podcastSelectionList,
      loading: podcastsLoading,
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().home_podcasts_wrapper),
      fetchNextPage: fetchNextPagePodcasts
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(92119);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36697:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","container":"index_container__HpKSV","inner-container":"index_inner-container__QYA9t","home_stations_wrapper":"index_home_stations_wrapper__UAcRH","home_podcasts_wrapper":"index_home_podcasts_wrapper__4smpy"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,2962,6694,4357,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);